import React, { useEffect, useState, useImperativeHandle, useRef } from 'react';
import { message, Modal } from 'antd';
import { connect } from 'react-redux';
import TaskList from './taskList';
import Manuscript from './manuscript';
import TaskPicture from './taskPicture';
import TaskVideo from './taskVideo';
import Attachment from './attachment';
import ProjectsInfoModal from './projectsInfoModal/index';
import RelateProjectModal from './relateProjectModal';
import addTask from '../images/addTask.png';
import projectInfo from '../images/projectInfo.png';
import { getPlatformInfo, getAttachmentInfo } from '../../../actions/majorProjects';
import './index.scss';
import {permissionCheck} from "../../../utils";
import {
    shrinNavigateStauts, updataNavigateData,
    updateNavigateLevel2Data
} from "../../../actions";
import eventProxy from "../../../utils/eventProxy";


const ProjectInfo = (props) => {

    const tabs = [
        {
            title: '任务列表',
            selected: true,
        },
        {
            title: '稿件列表',
            selected: false
        },
        {
            title: '任务图片',
            selected: false,
        },
        {
            title: '任务视频',
            selected: false
        },
        {
            title: '美工附件',
            selected: false
        }
    ];

    const [tab, setTab] = useState(tabs);
    const [currentTab, setCurrentTab]  = useState(0);
    const [visible,setVisible] = useState(false);
    const projectInfoModal = useRef();
    const relateTaskModal =  useRef();
    const taskListRef = useRef();

    const changeProjectListModalVisible = (visible) => {
        setVisible(visible);
    }

    useImperativeHandle(props.refs, () => ({
        changeProjectListModalVisible: changeProjectListModalVisible
    }))

    const seeProjectInfo = (item) => {
        projectInfoModal.current.changeProjectsInfoModalVisible(true);
        props.changeProjectName(item.name);
        props.changeProjectCreater(item.manager);
        props.changeProjectContent(item.content);
        // let mediaIds = item.mediaIds.join(',')
        // getPlatformInfo({ids: mediaIds},function(res){
        //     if(res.status === 200 && res.msg === 'ok'){
        //         props.changePlatform(res.data);
        //     }
        // })
        if(item.fileIds && item.fileIds.length > 0){
            getAttachmentInfo(item.fileIds).then(res=>{
                let newFileList = [];
                res && res.map(item=>{
                    newFileList.push({
                        url:"images/file.png",
                        uid:item.id,
                        resourceId:item.id,
                        path:item.url,
                        status:"done",
                        name:item.name,
                        icon:<img src={"images/file.png"} width={70} height={90} />
                    })
                });
                props.changeProjectAttachment(newFileList);
            })
        }

    }


    const relateProject = () => {
        relateTaskModal.current.changeRelateTaskVisible(true);
    }

    const handleOk = () => {
        handleCancel();
        
    }

    const handleCancel = () => {
        setCurrentTab(0);
        changeProjectListModalVisible(false);
        props.search(1,props.params);
        props.resetData();
    }

    const changeTab = (index) => {
        setCurrentTab(index);  
    }

    const renderContent = (currentTab) => {
        const { id } = props;
        switch(currentTab){
            case 0 : return <TaskList id={id} refs={taskListRef} {...props}/>;  //任务列表页面
            case 1 : return <Manuscript id={id} />; //稿件列表页面
            case 2 : return <TaskPicture id={id}/>;  //任务图片页面
            case 3 : return <TaskVideo id={id}/>;  //任务视频页面
            case 4 : return <Attachment id={id}/>;  //美工附件页面
            default: break;
        }
    }

    const findUrlData = (url) => {
        let sons;
        let name;
        let stopFind = false;
        let find = (data, level, levelOneBrothers, levelOneName) => {
            if (stopFind)
                return;
            if ((!data.sons || data.sons.length === 0) && (!data.float_ || data.float_.length === 0)) {
                if (data.path === url) {
                    sons = levelOneBrothers;
                    name = levelOneName;
                    stopFind = true;
                }
                return;
            }
            let tempSons = data.float_;
            if (!tempSons || tempSons.length === 0) {
                tempSons = data.sons;
            }
            if (stopFind)
                return;
            tempSons && tempSons.map(item => {
                if (stopFind)
                    return;
                let tempItemSons = item.float_;
                if (!tempItemSons || tempItemSons.length === 0) {
                    tempItemSons = item.sons;
                }
                if (level == 0) {//取第一级的信息
                    find(item, level + 1, tempItemSons, item.name);
                } else {
                    find(item, level + 1, levelOneBrothers, levelOneName);
                }
            })
        };
        find({sons: props.navigateData}, 0, null, null);
        return {stopFind, sons, name};
    };

    const goAddTask =() => {
      
            if(permissionCheck("pms:newsActiviti:add")){
               
                let {stopFind, sons, name} = findUrlData('/newsActivityIndex/newsActivityIndex');
                if (stopFind) {
                    props.shrinNavigateStauts();
                    props.updateNavigateLevel2Data(name, sons);
                    window.location.hash = '/newsActivityIndex/newsActivityIndex';
                    setTimeout(() => {
                        eventProxy.trigger('addTask',props.id)
                    },10)
                }

            }else{
                message.error('当前用户无此权限')
            }
        //permissionCheck("pms:newsActiviti:add") ? window.location.hash=`#/newsActivityIndex/newsActivityIndex/interviewEventId/${props.id}/add` : message.error('当前用户无此权限')
       
    }

    const refreshTaskList=()=>{
        props.refs.current.searchFirst(1)
    }
    
    const {  id } = props;
    return(
        <>
            <Modal
                className="project-info-modal"
                width='70%'
                visible={visible}
                onCancel={handleCancel}
                onOk={handleOk}
                destroyOnClose
                footer={null}
            >
                <div className="info">
                    <div className="info-title">
                        <div className="info-title-left">
                            {
                                tab.map((item, index) => (<span className={`${currentTab === index ? 'selected' : ''}`} onClick={() => { changeTab(index) }} key={index}>{item.title}</span>))
                            }
                        </div>
                        <div className="info-title-right">
                            {/* {
                                permissionCheck("pms:newsActiviti:add") && */}
                                <div className="add"> 
                                    <img src={addTask} alt="" />
                                    <span>添加任务
                                        <div className="drop">
                                            <span onClick={goAddTask}>创建任务</span>
                                            <span  onClick={() => relateProject(props.item)}>关联任务</span>
                                        </div>
                                    </span>
                                </div>
                            {/* } */}
                            <div>
                                <img src={projectInfo} alt="" />
                                <span onClick={() => seeProjectInfo(props.item)}>项目信息</span>
                            </div>
                        </div>
                    </div>
                    <div className="info-content">
                        {renderContent(currentTab)}
                    </div>
                </div>
            </Modal>
            {/* 项目信息弹窗 */}
            <ProjectsInfoModal  refs={projectInfoModal} addOrUpdateModal={props.addOrUpdateModal} changeProjectListModalVisible={changeProjectListModalVisible} item={props.item} search={props.search} params={props.params}    />
            {/* 关联任务弹窗 */}
            <RelateProjectModal refs={relateTaskModal}  id={props.id} taskListRef={taskListRef} refreshTaskList={refreshTaskList} />
        </>  
    )
}

const mapStateToProps = (state) => {
    return {
        navigateData: state.systemReducer.navigateData,
        
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeModalTitle: (value) => dispatch({ type: 'CHANGE_MODAL_TITLE', payload: value }),
        changeProjectName: (value) => dispatch({ type: 'CHANGE_PROJECT_NAME', payload: value }),
        changeProjectCreater: (value) => dispatch({ type: 'CHANGE_PROJECT_CREATER', payload: value }),
        changeProjectContent: (value) => dispatch({ type: 'CHANGE_PROJECT_CONTENT', payload: value }),
        changeProjectAttachment: (value) =>dispatch({ type: 'CHANGE_PROJECT_ATTACHMENT', payload:value}),
        // changePlatform: (value) => dispatch({type: 'CHANGE_PLATFORM', payload: value}),
        resetData: () => dispatch({ type: 'RESET_DATA'}),
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        },
        updateNavigateLevel2Data: function (title, data) {
            return dispatch(updateNavigateLevel2Data(title, data));
        }
    }
}


export default connect(mapStateToProps,mapDispatchToProps)(ProjectInfo);